import React, { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import SplashScreen from "./SplashScreen";
import AppRouter from "./AppRouter";
import logo from "./logo.gif";
import "./App.scss";

const App = () => {
  const [showSplashScreen, setShowSplashScreen] = useState(true);

  useEffect(() => {
    setTimeout(function () {
      setShowSplashScreen(false);
    }, 2000);
  }, []);

  if (showSplashScreen) {
    return <SplashScreen />;
  }

  return (
    <BrowserRouter>
      <div>
        <div className="container-fluid">
          <div className="d-flex align-items-center flex-column justify-content-center h-100">
            <img src={logo} alt="logo" className="logo" />
          </div>
        </div>
        <div className="container-fluid top">
          <div className="row">
            <div className="col-12 p-0">
              <div className="min-vh-100 text-center m-0 d-flex flex-column justify-content-center">
                <AppRouter />
              </div>
            </div>
          </div>
        </div>
      </div>
    </BrowserRouter>
  );
};

export default App;
